import { useEffect } from "react";
import "./TablePagination.css";
import DynamicButton from "../../DynamicButton/DynamicButton";

const STORAGE_KEY = "table_items_per_page";

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const TablePagination = ({
  currentPage = 1,
  totalPages = 1,
  setCurrentPage,
  itemsPerPage = 10,
  setItemsPerPage,
  totalEntries = 0,
}) => {
  const safeTotalPages = Math.max(Number(totalPages) || 1, 1);
  const safeCurrentPage = Math.min(
    Math.max(Number(currentPage) || 1, 1),
    safeTotalPages,
  );

  // Load saved page size only once
  useEffect(() => {
    const savedSize = Number(localStorage.getItem(STORAGE_KEY));

    if (
      savedSize &&
      PAGE_SIZE_OPTIONS.includes(savedSize) &&
      savedSize !== itemsPerPage
    ) {
      setItemsPerPage(savedSize);
      setCurrentPage(1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Keep page valid when filtered data changes
  useEffect(() => {
    if (currentPage > safeTotalPages) {
      setCurrentPage(safeTotalPages);
    }

    if (currentPage < 1) {
      setCurrentPage(1);
    }
  }, [currentPage, safeTotalPages, setCurrentPage]);

  const handlePageSizeChange = (e) => {
    const newSize = Number(e.target.value);

    setItemsPerPage(newSize);
    setCurrentPage(1);
    localStorage.setItem(STORAGE_KEY, String(newSize));
  };

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, safeTotalPages));
  };

  return (
    <div className="custom-pagination">
      <div className="custom-page-size">
        <label htmlFor="pageSize">Show </label>

        <select
          id="pageSize"
          value={itemsPerPage}
          onChange={handlePageSizeChange}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>

        <span> entries</span>
      </div>

      <DynamicButton
        text="Prev"
        icon="fa-chevron-left"
        size="sm"
        variant="outline"
        disabled={safeCurrentPage <= 1}
        onClick={handlePrev}
      />

      <span className="custom-pagination-info">
        Page {safeCurrentPage} of {safeTotalPages}
      </span>

      <DynamicButton
        text="Next"
        icon="fa-chevron-right"
        size="sm"
        variant="outline"
        disabled={safeCurrentPage >= safeTotalPages}
        onClick={handleNext}
      />

      <div className="custom-total-count">
        Total: <strong>{totalEntries}</strong>
      </div>
    </div>
  );
};

export default TablePagination;
